export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/python.a5d067c.svg";